import React from 'react'

const DimensionDetail = ({settings, parentProduct, handleSettingsChanges}) => {

    return (
        <>

            <div className="flex justify-start">
                {parentProduct?.isMultiMeasurement &&
                    <div className="field-container mr-4">
                        <div className="field-label">
                            Product Size
                        </div>
                        <select
                            className="input-field"
                            id="size"
                            name="size"
                            disabled={true}
                            value={settings?.size}
                            onChange={handleSettingsChanges}>
                            <option value="">Choose Size</option>
                            {parentProduct?.sizes?.map((size, index) => (
                                <option key={index}
                                        value={size?.name}>{size?.name}</option>
                            ))}
                        </select>
                    </div>
                }

                {parentProduct?.allowHalfWidthDesign &&
                    <div className="field-container mb-2">
                        <div className="justify-start flex">
                            <input
                                type="checkbox"
                                className="h-6 w-6 mr-1"
                                id="halfWidthDesign"
                                name="halfWidthDesign"
                                value={settings?.halfWidthDesign}
                                checked={settings?.halfWidthDesign}
                                onChange={handleSettingsChanges}>
                            </input>
                            <div className=''>
                                <label className='field-label self-center'
                                       htmlFor='halfWidthDesign'>Half Width Design</label>
                            </div>
                        </div>
                    </div>
                }
            </div>

            <div className="ml-2 field-label">
                Dimension (Width x Height)
            </div>

            <div className="flex justify-start move-up-10">
                <div className="field-group-container">
                    <div className="field-container">
                        <input type="number" placeholder="Width"
                               id="width"
                               readOnly
                               name="width"
                               value={settings?.width}
                               onChange={() => {
                               }}
                               className="input-field number-input-field"/>
                    </div>
                    <div className="field-container">
                        <input type="number" placeholder="Height"
                               id="height"
                               readOnly
                               name="height"
                               value={settings?.height}
                               onChange={() => {
                               }}
                               className="input-field number-input-field"/>
                    </div>
                </div>
            </div>

        </>
    )
}

export default DimensionDetail
